/* eslint-disable */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { JSONTree } from 'react-json-tree';
import Modal from 'modules/common/components/Modal';

function ViewLogDetailModal({
  data,
}) {

  const parseNestedObject = (obj) => {
    return _.mapValues(obj, value => {
        if (_.isString(value)) {
            try {
                return JSON.parse(value);
            } catch (error) {
                console.error('Error parsing JSON:', error);
                return value; 
            }
        } else if (_.isObject(value)) {
            return parseNestedObject(value);
        }
        return value;
    });
  }

  return (
    <Modal.Body>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 px-0">
            <h4>Old Values</h4>
            <JSONTree data={parseNestedObject(_.get(data, "old_values")) || {}} />
          </div>
          <div className="col-12 px-0">
            <h4>New Values</h4>
            <JSONTree data={parseNestedObject(_.get(data, "new_values")) || {}} />
          </div>
        </div>
      </div>
    </Modal.Body>
  );
}

ViewLogDetailModal.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
};

ViewLogDetailModal.defaultProps = {
  data: '',
};

export default ViewLogDetailModal;
